import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { ArticleCategory } from '~/utils/types'

export default function useSeo(category?: ArticleCategory) {
  const globalStore = useGlobalStore()

  const defaultTitle = `最新消息｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const title = category ? `${category?.seo?.meta_title}｜${defaultTitle}` : defaultTitle
  const description = category?.seo?.meta_description || globalStore.seoDescriptions.news
  const url = category ? `${import.meta.env.VITE_DOMAIN}/news/${category?.seo?.meta_slug || category?.id}` : `${import.meta.env.VITE_DOMAIN}/news`

  let breadcrumbs = [{ title: '最新消息', isActive: !category, url: category ? '' : '/news' }]
  if (category) {
    breadcrumbs.push({ title: category?.seo?.meta_title, isActive: true, url: url })
  }
  globalStore.setBreadcrumbs(breadcrumbs)

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: category?.seo?.og_image?.link,
    keywords: category?.seo?.meta_keywords.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  let itemListElement = [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首頁',
      item: import.meta.env.VITE_DOMAIN
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: '最新消息',
      item: `${import.meta.env.VITE_DOMAIN}/news`
    }
  ]

  if (category) {
    itemListElement.push({
      '@type': 'ListItem',
      position: 3,
      name: category?.seo?.meta_title,
      item: url
    })
  }

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: itemListElement as any
      }
    ]
  })
}
